<template>
  <div>
    <div
      class="modal animated fadeIn"
      tabindex="-1"
      id="jobcardsLoaderModal"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-sm" style="top: 40%">
        <div class="modal-content">
          <div class="modal-body">
            <div class="modal-fluid">
              <div class="row">
                <div class="col-md-12">
                  <center>
                    <img src="static/assets/images/ajax-loader.gif" /> updating,
                    please wait..
                  </center>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size: 15px; font-weight: bold"
          >manage job cards</small
        >
      </legend>
      <div></div>
      <div class="jobcardsLoader">
        <span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
        <i
          class="fa fa-spinner fa-spin"
          style="font-size: 24px; color: blue"
        ></i
        >loading jobcards...
      </div>
      <vue-good-table
        :columns="columns"
        :rows="systemJobcards"
        :pagination-options="{
          enabled: true,
          mode: 'records',
          perPage: 6,
          position: 'bottom',
          perPageDropdown: [3, 7, 9],
          dropdownAllowAll: false,
          setCurrentPage: 1,
          nextLabel: 'next',
          prevLabel: 'prev',
          rowsPerPageLabel: 'Rows per page',
          ofLabel: 'of',
          pageLabel: 'page', // for 'pages' mode
          allLabel: 'All',
        }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'Status'">
            <span v-if="props.row.status === 0">
              <button class="btn btn-danger btn-sm btn-flat">
                <i class="fa fa-gear"></i> NOT CLEARED
              </button>
            </span>
            <span v-else-if="props.row.status === 1">
              <button class="btn btn-success btn-sm">
                <i class="fa fa-check"></i> CLEARED
              </button>
            </span>
          </span>
          <span v-else-if="props.column.field == 'Action'">
            <span v-if="props.row.status === 0">
              <button
                class="btn btn-info btn-sm"
                @click="updateJobcard(props.row.id)"
              >
                <i class="fa fa-edit"></i> Clear Jobcard
              </button>
            </span>
            <span v-else-if="props.row.status === 1">
              <button class="btn btn-success btn-sm">
                <i class="fa fa-check"></i> CLEARED
              </button>
            </span>
          </span>
          <span v-else-if="props.column.field == 'View'">
            <button class="btn btn-primary btn-sm" @click="viewjobcardsales(props.row.id)">
              <i class="fa fa-file-pdf-o"></i> VIEW
            </button>
          </span>
        </template>
      </vue-good-table>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Job card no",
          field: "job_card_no",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter number",
          },
        },
        {
          label: "Truck number",
          field: "truck_no",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter truck number",
          },
        },
        {
          label: "status",
          field: "Status",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Date",
          field: "job_date",
          type: "date",
          dateInputFormat: "yyyy-MM-dd", // expects 2018-03-16
          dateOutputFormat: "MMM do yyyy",
          filterOptions: {
            enabled: true, // enable filter for this column
          }, // outputs Mar 16th 2018
        },
        {
          label: "Action",
          field: "Action",
          width: "122px",
          html: true,
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "View",
          field: "View",
          width: "122px",
          html: true,
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
      ],
    };
  },
  created() {
    this.loadJobcards();
  },
  computed: {
    ...mapGetters(["systemJobcards"]),
  },
  methods: {
    ...mapActions(["loadJobcards", "updateJobcard", 'viewjobcardsales']),
  },
};
</script>


// WEBPACK FOOTER //
// src/trucks/managejobcards.vue